import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import SessionCategoryForm from "./SessionCategoryForm";
import { createSessionCategory } from "../../store/slices/sessionCategorySlice";

const AddSessionCategory = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        name: "",
        status: "active",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = "Name is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            await dispatch(createSessionCategory(formData)).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Session Category added successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate("/session-categories");
        } catch (err) {
            Swal.fire({
                title: "Error",
                text: err.message || "Failed to add Session Category",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <SessionCategoryForm
                                formData={formData}
                                handleChange={handleChange}
                            />

                            <div className="row mt-3">
                                <div className="col-md-2 ms-auto">
                                    <button type="submit" className="btn btn-primary w-100">
                                        <i className="ri-save-3-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddSessionCategory;
